import Icon from './components/Icon';

const IconClose = ({ type = 'filled', ...props }: any) => {
	const typeModifier = `--${type}`;

	return <Icon handle={props.handle} id={`sti-close${typeModifier}`} {...props} />;
};

export default IconClose;
